import React, { useEffect, useRef, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { createStructuredSelector } from 'reselect';
import { withNamespaces } from 'react-i18next';
import { get } from 'lodash';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { canUseDOM } from '../../../utils/canUseDOM';
import { setEqualHeight } from '../../../utils/setEqualHeight';

import {
  selectedFiltersData,
  filteredData,
  filtersData,
} from '../Filters/redux/selectors';
import useStyles from './style';
import {
  updateFiltersData,
  getFilterdInfoData,
  removeFilterdListById,
} from '../Filters/redux/actions';
import DctSvgIcon from '../../../components/atoms/Svg';
import Grid from '../../../components/molecules/Grid';
import Typography from '../../../components/atoms/Typography';
import { getHelperKeysFromDictionary } from '../../../../utils/utility';
import { dictionaryKeys } from './constants';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import CarouselCard from '../../../components/molecules/CarouselCard';
import {
  FILTERED_LIST_CONTAINER,
  SELECTED_FILTERE_CONTAINER,
} from './locators';
import ButtonMUI from '../../../components/atoms/Button';
import clsx from 'clsx';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import { getPriceRange } from '../../../utils/getPriceRange';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import {
  EVENT_TYPE,
  LISTING_TYPE,
  TAGS,
  FAVORITE_LISTING_TEMPLATE_ID,
} from '../../../../constants/index';
import { getCardCategoryTags } from '../../../utils/getCardCategoryTags';
import { getRedirectionUrl } from '../../../utils/getRedirectionUrl';
import { getCurrentLanguage } from '../../../utils/getCurrentLanguage';
import { getPageName } from '../../../utils/getPageComponentInfo';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getLocalStorage } from './../../../../utils/localStorage';
import FavoriteContext from './../../../../context/favorite/FavoriteContext';

const FilteredList = props => {
  const [favoriteClicked, setFavoriteClicked] = useState('');
  let [loadedResultCount, setLoadedResultCount] = useState(0);
  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);
  let contentType = get(
    props,
    'sitecoreContext.route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();
  const templateName = get(props, 'sitecoreContext.route.templateName', '');
  const templateId = get(props, 'sitecoreContext.route.templateId', '');
  const vadHeader = get(
    props,
    'sitecoreContext.VAAStaticRoute.sitecore.route.placeholders.vad-header',
    []
  );

  useEffect(() => {
    const favouriteBasket = vadHeader.find(
      item => item.componentName === 'FavoriteBasket'
    );
    const favIsActive = get(
      favouriteBasket,
      'fields["Is Active"].value',
      false
    );
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive);
  }, [vadHeader]);
  // this key is used to handle global search cases
  const isGlobalSearchTemplate = templateName === 'GlobalSearchResult';

  const carouselCardWrapper = useRef();

  const { favorites } = useContext(FavoriteContext);

  const addAnalyticsInfo = () => {
    const title = get(
      props,
      'sitecoreContext.route.fields.pageHeading.value',
      ''
    );
    const dynamicLabel = `${title}-${get(
      analyticsData,
      'pageBodyInteraction.loadMoreBtnClick.action'
    )}`;
    const obj = {
      ...get(analyticsData, 'pageBodyInteraction.loadMoreBtnClick'),
      ...{
        label: createDynamicLabels([
          getPageName(props),
          props.componentName,
          dynamicLabel,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  useEffect(() => {
    if (canUseDOM) {
      const lazyloadedImages = document.querySelectorAll('.lazyloaded');
      lazyloadedImages &&
        lazyloadedImages.forEach(img => {
          img.classList.remove('lazyloaded');
          img.classList.add('lazyload');
        });
      // Make sure address aligns with it self throughtout cards.
      setTimeout(() => {
        setEqualHeight(carouselCardWrapper.current, '.bot-area');
      }, 500)
    }
  });
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', () => {
        // Make sure address aligns with it self throughtout cards.
        setEqualHeight(carouselCardWrapper.current, '.bot-area');
      });
    }
  }, []);
  const classes = useStyles({ contentType });
  const localFavorites = getLocalStorage('favorites' || '[]');
  const dictionary = props && props.t;
  const { appConfig = {} } = props;
  const ratingOutOf = dictionary('outOf5');
  const language = getCurrentLanguage(props);
  const helperKeys = getHelperKeysFromDictionary(dictionary, dictionaryKeys);
  const {
    showingText,
    resultsText,
    loadMoreText,
    noResultFoundKey,
    multiResultFoundKey,
    singleResultFoundKey,
  } = helperKeys;
  const { results, totalResults } = get(props, 'filteredData.data', {});

  const { payload = {} } = props.filteredData;
  const resultsLength = results && results.length;

  const unFavoriteAction = () => {
    if (favoriteClicked) {
      props.removeFilterdListById({
        filteredId: favoriteClicked,
      });

      let apiPayload = payload;
      if (apiPayload.payload?.itemIDs) {
        apiPayload.payload.itemIDs = JSON.parse(localFavorites);
        var _offset = resultsLength - 1;
        apiPayload.payload.offset = _offset;
        //For attribute listing page load more card limits are driven by sitecore,
        var _limit = 1;
        apiPayload.payload.limit = _limit;
        apiPayload.payload.isFillableRequest = true;
        apiPayload.isLoadMoreClicked = true;

        if (totalResults > resultsLength && totalResults > 9) {
          _getOneMoreData(
            resultsLength + _limit,
            apiPayload.payload.offset,
            totalResults,
            apiPayload
          );
        }
      }
    }
  };
  const _getOneMoreData = (resultsLength, offset, totalResults, apiPayload) => {
    props.getFilterdInfoData(apiPayload);
  };

  useEffect(() => {
    if (props.componentName == 'FavoriteSubLayout') {
      unFavoriteAction();
    }
  }, [favoriteClicked]);

  useEffect(() => {
    if (
      props.componentName == 'FavoriteSubLayout' &&
      results &&
      results.length > 0
    ) {
      const oldResultIds = results.map(item => item.itemUniqueKey);
      const diff = oldResultIds.filter(x => favorites.indexOf(x) === -1);
      if (diff.length === 1) {
        const removedId = diff[0];
        setFavoriteClicked(removedId);
      }
    }
  }, [favorites]);

  const { searchTerm, isAttributeListingPage, sitecoreContext } = props;
  if (!get(props, 'filteredData.data.results')) {
    return '';
  }

  const resultFoundKey =
    resultsLength > 1 ? multiResultFoundKey : singleResultFoundKey;
  let defaultGooglePlaceId =
    sitecoreContext &&
    sitecoreContext.route &&
    sitecoreContext.route.fields &&
    sitecoreContext.route.fields.googlePlaceId;

  const renderText = (label, variant) => {
    return (
      <Typography variant={variant} gutterBottom={false}>
        <Text field={label} />
      </Typography>
    );
  };

  // selecting statement to show after receiveing results for different scenarios
  let displayResultsText = '';
  let _totalResult = totalResults;

  if (results && results.length === 0) {
    displayResultsText = (
      <div className={classes.numberResultFoundText}>
        {renderText(noResultFoundKey, 'h5')}
      </div>
    );
  } else if (isGlobalSearchTemplate) {
    displayResultsText = (
      <div
        className={clsx(classes.numberResultFoundText, classes.resultSpacing)}
      >
        {renderText(
          {
            value:
              resultFoundKey &&
              resultFoundKey.value &&
              resultFoundKey.value.split('{0}')[0],
          },
          'h5Bold'
        )}
        {renderText({ value: _totalResult }, 'h5Bold')}
        {renderText(
          {
            value:
              resultFoundKey &&
              resultFoundKey.value &&
              resultFoundKey.value.split('{0}')[1],
          },
          'h5Bold'
        )}
        {renderText({ value: ` "${searchTerm}"` }, 'h5Bold')}
      </div>
    );
  } else {
    displayResultsText = (
      <div className={classes.numberResultFoundText}>
        {renderText(showingText, 'h5')}
        {renderText({ value: ` ${_totalResult} ` }, 'h5Bold')}
        {renderText(resultsText, 'h5')}
      </div>
    );
  }

  const getAdditionalCardAttributes = item => {
    let other = {};
    let featuredEvent;
    if (contentType === EVENT_TYPE.toLowerCase() || item.contentType.toLowerCase() === EVENT_TYPE.toLowerCase()) {
      if (item.isFeatured) {
        featuredEvent = dictionary('featuredText') || '';
      }
      other = {
        startDate: item.startDate,
        endDate: item.endDate,
        openTime: item.openTime,
        closeTime: item.closeTime,
        umbrellaEventCount: item.umbrellaEventCount,
        isEventListing: true,
        peopleInterested:
          item.interestedCount &&
          `${item.interestedCount} ${dictionary('interestedText')}`,
        eventType: {
          featured: featuredEvent,
          isPaid: item.eventType,
        },
        locationTitle:
          item.location_Titles &&
          item.location_Titles.length > 0 &&
          item.location_Titles[0],
        region:
          item.location_Regions &&
          item.location_Regions.length > 0 &&
          item.location_Regions[0],
        language,
        urlSlug: item.urlSlug,
        eventCategories: item.eventCategories,
      };
    }
    return other;
  };

  const onLoadMoreClick = () => {
    addAnalyticsInfo();
    let apiPayload = payload;
    apiPayload.payload.offset = resultsLength;
    //For attribute listing page load more card limits are driven by sitecore,
    apiPayload.payload.limit = isAttributeListingPage
      ? Number(getDictionaryText('attributeLoadMoreCount'))
      : 6;
    apiPayload.isLoadMoreClicked = true;
    props.getFilterdInfoData(apiPayload);
    setLoadedResultCount(loadedResultCount + 6);
  };

  const payloadForSearchCall = language => {
    let favData = JSON.parse(getLocalStorage('favorites') || '[]');

    let solrPayloadToFetchFilter = {};
    solrPayloadToFetchFilter.itemIDs = favData;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    solrPayloadToFetchFilter.limit = 9;
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [];
    solrPayloadToFetchFilter.sortingOrder = {
      order: 'asc',
      sortBy: 'name',
    };

    return solrPayloadToFetchFilter;
  };

  const fetchFavoriteListing = () => {
    const { appConfig = {} } = props;

    const payload = payloadForSearchCall(language);
    props.getFilterdInfoData({
      apiUrl: `${appConfig.SOLR_FAVORITE_SEARCH_API}`,
      payload: payload,
    });
  };
  const onFilterRemove = event => {
    const { name, checked, displayValue } = event.target;
    const target = {
      name,
      value: displayValue,
      checked,
    };
    props.updateFiltersData(target);
    if (props.componentName == 'FavoriteSubLayout') {
      fetchFavoriteListing();
    }
  };

  const getFilterDisplayText = key => {
    const filtersData = get(props, 'filtersData.data', '');
    if (filtersData && filtersData.length) {
      for (let filter of filtersData) {
        if (filter.listItems && filter.listItems.length) {
          for (let listItem of filter.listItems) {
            if (listItem.groupheading) {
              if (listItem.groupheading.key === key) {
                return listItem.groupheading.value;
              } else if (listItem.groupItems && listItem.groupItems.length) {
                for (let groupItem of listItem.groupItems) {
                  if (groupItem.key.value === key) {
                    return groupItem.displayText.value;
                  }
                }
              }
            } else if (listItem.fields) {
              if (listItem.fields.key.value === key) {
                // Handle Trip Advisor Rating Tags Display Text
                if (filter.fieldName.value === 'tripadvisorrating') {
                  let filterKey = listItem.fields.key.value;
                  if (filterKey === '[0 TO 5]') {
                    return getDictionaryText('anyRating');
                  } else if (filterKey === '5') {
                    return '●●●●●';
                  } else if (filterKey === '[4 TO 5]') {
                    return '●●●●○' + ' ' + getDictionaryText('andUp');
                  } else if (filterKey === '[3 TO 5]') {
                    return '●●●○○' + ' ' + getDictionaryText('andUp');
                  }
                } else {
                  return listItem.fields.displayText.value;
                }
              }
            }
          }
        }
      }
      return key;
    } else {
      return key;
    }
  };

  const renderFilters = selectedFilters => {
    let filtersDOM = [];
    Object.keys(selectedFilters).forEach(key => {
      const value = selectedFilters[key];

      if (Array.isArray(value) && value.length > 0) {
        for (let val of value) {
          const displayValue = getFilterDisplayText(val);
          let data = {};
          data = {
            target: {
              name: key,
              value: displayValue,
              displayValue: val,
              checked: false,
            },
          };
          filtersDOM.push(
            <div className={classes.filters}>
              {renderText({ value: displayValue }, 'labelBlack')}
              <DctSvgIcon
                name="CloseIcon"
                className={classes.crossIcon}
                id={`${key}_${displayValue}`}
                onClick={() => onFilterRemove(data)}
              />
            </div>
          );
        }
      } else if (value && !Array.isArray(value)) {
        if (key === 'startDate') {
          const startText = getFilterDisplayText(value);
          const endText = getFilterDisplayText(selectedFilters['endDate']);
          const displayValue = `${startText} to ${endText}`
          let data = {};
          data = {
            target: {
              name: key,
              value: '',
              displayValue: '',
              checked: false,
            },
          };
          filtersDOM.push(
            <div className={classes.filters}>
              {renderText({ value: displayValue }, 'labelBlack')}
              <DctSvgIcon
                name="CloseIcon"
                className={classes.crossIcon}
                id={`${key}_${displayValue}`}
                onClick={() => onFilterRemove(data)}
              />
            </div>
          );
        } else if (key !== 'endDate') {
          const displayValue = getFilterDisplayText(value);
          let data = {};
          data = {
            target: {
              name: key,
              value: '',
              displayValue: '',
              checked: false,
            },
          };
          filtersDOM.push(
            <div className={classes.filters}>
              {renderText({ value: displayValue }, 'labelBlack')}
              <DctSvgIcon
                name="CloseIcon"
                className={classes.crossIcon}
                id={`${key}_${displayValue}`}
                onClick={() => onFilterRemove(data)}
              />
            </div>
          );
        }

      }
    });

    return filtersDOM;
  };
  const renderResults = results => {
    let keys =
      props &&
      props.t &&
      props.t(contentType) &&
      props.t(contentType && contentType.toLowerCase()) &&
      props.t(contentType.toLowerCase()).split(',');
    let tags;
    return (
      results &&
      results.map((item, i) => {
        let priceTagData = getPriceRange(item.priceTagsKeys);
        let itemContentType = get(item, 'contentType', '').toLowerCase();
        if (
          (isGlobalSearchTemplate || isAttributeListingPage) &&
          itemContentType
        ) {
          /*
           * In case of GlobalSearchTemplate we extract contentType from API response
           * and show different tags for different categories of results
           */
          tags = getCardCategoryTags(
            item,
            dictionary(`${itemContentType}${TAGS}`)
          );
        } else if (templateId === FAVORITE_LISTING_TEMPLATE_ID) {
          if (itemContentType === EVENT_TYPE) {
            tags = item.eventCategories;
          } else {
            tags = getCardCategoryTags(
              item,
              dictionary(`${itemContentType}${TAGS}`)
            );
          }
        } else {
          tags = getCardCategoryTags(item, dictionary(`${contentType}${TAGS}`));
        }

        let dymnamicProps = [];
        if (keys && keys.length > 0) {
          keys.forEach(key => {
            dymnamicProps[key] = get(item, key, '');
          });
        }
        const thumbnailSrc = {
          src: get(item, 'thumbnailImage', ''),
          alt: get(item, 'name', ''),
        };
        let checkContentType = contentType;
        if (isGlobalSearchTemplate || isAttributeListingPage || props.componentName == 'FavoriteSubLayout') {
          checkContentType = itemContentType;
        }
        const thumbnailImage = {
          value:
            checkContentType === EVENT_TYPE &&
              get(item, 'itemUniqueKey', '') !==
              dictionary('itemUniqueKeyEventListing')
              ? thumbnailSrc
              : get(item, 'thumbnailImage', ''),
        };

        return (
          <Grid
            item
            lg={isGlobalSearchTemplate ? 12 : 4}
            key={i}
            className={clsx(isGlobalSearchTemplate && classes.horizontalCard)}
          >
            <CarouselCard
              title={get(item, 'name', '')}
              desktopImage={thumbnailImage}
              mobileImage={thumbnailImage}
              aspectRatioNeeded={contentType !== EVENT_TYPE}
              imageCtaUrl={
                contentType === EVENT_TYPE || itemContentType === EVENT_TYPE
                  ? getRedirectionUrl(item, language)
                  : get(item, 'itemUrl', '')
              }
              ctaLink={tags}
              cardType={
                isGlobalSearchTemplate
                  ? 'searchResult'
                  : contentType === EVENT_TYPE || itemContentType === EVENT_TYPE
                    ? EVENT_TYPE
                    : LISTING_TYPE
              }
              description={
                isGlobalSearchTemplate && get(item, 'description', '')
              }
              ratingOutOf={ratingOutOf}
              pageName={getPageName(props)}
              componentName={props.componentName}
              {...dymnamicProps}
              {...getAdditionalCardAttributes(item)}
              highlightWords={searchTerm}
              expenseRange={priceTagData}
              viewsCount={get(item, 'viewsCount', '')}
              num_reviews={get(item, 'tripAdvisorNumberOfReviews', '')}
              rating_image_url={get(item, 'tripAdvisorRatingImageURL', '')}
              googlePlaceId={get(item, 'googlePlaceId', '')}
              itemUniqueKey={get(item, 'itemUniqueKey', '')}
              isShowFavorite={setFavoriteClicked}
              defaultGooglePlaceId={defaultGooglePlaceId}
              language={language}
              googlePlacesAPI={appConfig.GOOGLE_PLACES_API}
              forcedRatio={
                contentType === EVENT_TYPE || itemContentType === EVENT_TYPE
                  ? '3x2'
                  : null
              }
              showFavoriteIcon={hasFavouriteBasket}
            />
          </Grid>
        );
      })
    );
  };

  return (
    <div
      className={classes.resultSection}
      data-locators={FILTERED_LIST_CONTAINER}
    >
      {displayResultsText}
      <div
        className={clsx(
          classes.sectectedFilterSection,
          isGlobalSearchTemplate && classes.resultSpacing
        )}
        data-locator={SELECTED_FILTERE_CONTAINER}
      >
        {renderFilters(get(props, 'selectedFiltersData.data'), {})}
      </div>
      <Grid
        container
        classes={{ root: classes.spacing }}
        className={clsx(isGlobalSearchTemplate && classes.resetSpacing)}
        ref={carouselCardWrapper}
      >
        {renderResults(results)}
      </Grid>
      {totalResults > resultsLength && totalResults > 9 && (
        <Grid item className={classes.loadMoreSection}>
          <ButtonMUI
            buttonType={'form'}
            type={'button'}
            onClick={() => onLoadMoreClick()}
            hasBorder={false}
            field={{ value: { text: renderText(loadMoreText, 'body2Bold') } }}
            iconOnly={false}
            iconName={'ExpandMoreIcon'}
            // This comments for Event page
            className={contentType === EVENT_TYPE && classes.eventBtnColor}
          />
        </Grid>
      )}
    </div>
  );
};

export const mapStateToProps = createStructuredSelector({
  selectedFiltersData: selectedFiltersData,
  filteredData: filteredData,
  filtersData: filtersData,
});

export const mapDispatchToProps = dispatch => {
  return {
    updateFiltersData: params => dispatch(updateFiltersData(params)),
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
    removeFilterdListById: params => dispatch(removeFilterdListById(params)),
  };
};

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(FilteredList))
  )
);
export { FilteredList as FilteredListTest };
